(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300));
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxi-servies-keuze"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  function setup() {
    document.querySelectorAll('.maxi-servies__collections').forEach(grid => {
      if (initialized.has(grid)) return;
      initialized.add(grid);
      grid.classList.add('is-masonry');
      let frame;
      const layout = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          [...grid.children].forEach(card => {
            const span = Math.ceil(card.getBoundingClientRect().height + 24);
            const value = 'span ' + span;
            if (card.style.gridRowEnd !== value) card.style.gridRowEnd = value;
          });
        });
      };
      const observer = new ResizeObserver(layout);
      observer.observe(grid);
      [...grid.children].forEach(card => observer.observe(card));
      layout();
      document.fonts.ready.then(layout);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(grid)) { observer.disconnect(); cancelAnimationFrame(frame); }
      }, { once: true });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxistock-pro-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const page = document.querySelector('.pro-campaign');
  if (!page) return;
  const sticky = page.querySelector('.pro-mobile-action');
  if (!sticky || !('IntersectionObserver' in window)) return;
  const heroButton = page.querySelector('.pro-hero-copy > .pro-cta');
  if (!heroButton) return;
  let heroPassed = false;
  let submitVisible = false;
  let completed = false;
  const updateSticky = () => { sticky.hidden = !heroPassed || submitVisible || completed; };
  updateSticky();
  new IntersectionObserver(entries => {
    const entry = entries[0];
    heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    updateSticky();
  }, { threshold: 0 }).observe(heroButton);
  const observer = new IntersectionObserver(entries => {
    submitVisible = entries[0].isIntersecting;
    updateSticky();
  }, { threshold: 0 });
  let attempts = 0;
  function connectForm() {
    const root = page.querySelector('.pro-form shopify-forms-embed')?.shadowRoot;
    const submit = root?.querySelector('button[type="submit"]');
    if (submit) {
      observer.observe(submit);
      new MutationObserver(() => { if (!root.contains(submit)) { completed = true; updateSticky(); } }).observe(root, { childList: true, subtree: true });
    } else if (++attempts < 120) setTimeout(connectForm, 250);
  }
  connectForm();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxistock-pro-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maxistock-pro-catalog')) {
  customElements.define('maxistock-pro-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.category = 'all';
      this.limit = 20;
      const setView = (view) => {
        this.dataset.view = view === 'grid' ? 'grid' : 'list';
        this.querySelectorAll('[data-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.viewChoice === this.dataset.view)));
      };
      try { setView(localStorage.getItem('maxistock-pro-view')); } catch { setView('list'); }
      this.querySelector('.maxistock-pro-view-switch').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-view-choice]');
        if (!button) return;
        setView(button.dataset.viewChoice);
        try { localStorage.setItem('maxistock-pro-view', this.dataset.view); } catch {}
      });
      this.cards = Array.from(this.querySelectorAll('.maxistock-pro-card'));
      this.grid = this.querySelector('.maxistock-pro-grid');
      this.search = this.querySelector('[data-search]');
      this.brand = this.querySelector('[data-brand]');
      this.sort = this.querySelector('[data-sort]');
      this.querySelector('.maxistock-pro-filters').hidden = false;
      this.addEventListener('input', () => this.update());
      this.querySelector('[data-more]').addEventListener('click', () => {
        const shown = this.limit;
        this.limit += 20;
        this.update(false);
        const next = [...this.grid.children].filter(card => !card.hidden)[shown];
        next?.querySelector('a')?.focus({preventScroll:true});
      });
      this.addEventListener('change', () => this.update());
      this.addEventListener('click', (event) => {
        const category = event.target.closest('[data-category]');
        if (category) { this.category = category.dataset.category; history.replaceState(null, '', '#pro-' + this.category); this.update(); }
        if (event.target.closest('[data-reset]')) {
          this.category = 'all'; history.replaceState(null, '', '#pro-all'); this.search.value = ''; this.brand.value = ''; this.sort.value = 'recommended'; this.update();
        }
      });
      this.applyHash = () => {
        const group = location.hash.replace('#pro-', '');
        if (['all','pans','pots','cutlery','tableware','glasses','kitchen'].includes(group)) {
          this.category = group; this.search.value = ''; this.brand.value = ''; this.update();
          this.querySelector('#ProAssortment').scrollIntoView({block:'start'});
        }
      };
      window.addEventListener('hashchange', this.applyHash);
      this.update(); this.applyHash();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.applyHash); }
    update(reset = true) {
      if (reset) this.limit = 20;
      const query = this.search.value.trim().toLocaleLowerCase();
      let count = 0;
      const cards = [...this.cards].sort((a,b) => {
        if (this.sort.value === 'asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      cards.forEach(card => {
        const excluded = (this.category !== 'all' && card.dataset.group !== this.category) ||
          (this.brand.value && card.dataset.vendor !== this.brand.value) ||
          !card.dataset.title.toLocaleLowerCase().includes(query);
        if (!excluded) count++;
        card.hidden = excluded || count > this.limit;
        this.grid.appendChild(card);
      });
      this.querySelectorAll('[data-category]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.category === this.category)));
      this.querySelector('[data-count]').textContent = String(count);
      const progress = this.querySelector('[data-progress]');
      progress.textContent = progress.dataset.template.replace('[shown]', String(Math.min(count, this.limit))).replace('[total]', String(count));
      this.querySelector('[data-more-wrapper]').hidden = count === 0;
      this.querySelector('[data-more]').hidden = count <= this.limit;
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.querySelector('[data-reset]').hidden = this.category === 'all' && !query && !this.brand.value && this.sort.value === 'recommended';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
